import { useEffect, useState } from "react";

const useFetchCities = (stateName, statecityData, cityApiKey) => {
  const [cityArray, setCityArray] = useState([]);

  useEffect(() => {
    const selectedState = statecityData.find((ele) => ele.name === stateName);
    const stateCode = selectedState?.iso2;

    const fetchCities = async (code) => {
      const headers = new Headers();
      headers.append("X-CSCAPI-KEY", cityApiKey);

      try {
        const response = await fetch(
          `https://api.countrystatecity.in/v1/countries/IN/states/${code}/cities`,
          {
            method: "GET",
            headers,
            redirect: "follow",
          }
        );

        if (!response.ok)
          throw new Error(`HTTP error! Status: ${response.status}`);

        const cityData = await response.json();
        setCityArray(cityData);
      } catch (error) {
        console.error("Error fetching cities:", error);
        setCityArray([]); // fallback to empty array
      }
    };

    if (stateCode) fetchCities(stateCode);
  }, [stateName, statecityData, cityApiKey]);

  return cityArray;
};

export default useFetchCities;
